import React from 'react';

import { clubLogo } from '../domain/clubs';
import { creditsPerRemainingSlot } from '../domain/team';

// Il tabellone dell'asta offline: la stessa banda alta della modalita
// spettatore, ma con dentro i comandi, perche' qui chi guarda e chi assegna
// sono la stessa persona davanti allo stesso schermo.
//
// Non riusa TvLot ne' PlayerDisplay. TvLot legge un lotto del server (offerta
// corrente, chi e' in testa, secondi) che offline non esiste; PlayerDisplay e'
// una scheda da leggere a cinquanta centimetri, con il nome grande quanto il
// titolo di un pannello. Qui si riusano l'idioma `.tv-*` e le derivazioni di
// domain/team, non i componenti.

function surnameOf(player) {
    return player?.Cognome || player?.['Nome Completo'] || '';
}

function stat(value) {
    return value === undefined || value === null || value === '' ? '—' : value;
}

export default function OfflineStage({
    player,
    participants,
    participant,
    onParticipant,
    price,
    onPrice,
    onAssign,
    team,
    ceiling,
    playersPerTeam,
}) {
    if (!player) {
        return (
            <section className="stage stage--empty" aria-label="Giocatore in asta">
                <p className="tv-status">
                    Cerca un giocatore per metterlo
                    <span className="tv-status-name">sul tabellone</span>
                </p>
            </section>
        );
    }

    const fvm = Number.parseFloat(player['FVM Attuale']);
    const perSlot = team ? creditsPerRemainingSlot(team, playersPerTeam) : 0;

    return (
        <section className="stage" aria-label="Giocatore in asta">
            {player['URL Immagine'] && (
                <img className="stage-photo" src={player['URL Immagine']} alt="" />
            )}

            {/* Come nella schermata da proiettare: occhiello, nome grandissimo,
                dettagli sotto. Il nome per esteso resta, in piccolo — serve per
                distinguere due omonimi, non per leggerlo dal fondo della
                stanza. */}
            <div className="stage-info">
                <p className="tv-eyebrow">In asta</p>
                <h2 className="stage-name">{surnameOf(player)}</h2>
                <p className="stage-fullname u-truncate">{player['Nome Completo']}</p>
                <p className="stage-meta">
                    <span className="badge badge--role" data-role={player.Ruolo}>
                        {player.Ruolo}
                    </span>
                    {player.Squadra && (
                        <span className="tv-club">
                            {clubLogo(player.Squadra) && (
                                <img src={clubLogo(player.Squadra)} alt="" />
                            )}
                            {player.Squadra}
                        </span>
                    )}
                </p>
                <dl className="stage-stats">
                    <div className="stage-stat">
                        <dt>Media voto</dt>
                        <dd className="num">{stat(player['Media Voto'])}</dd>
                    </div>
                    <div className="stage-stat">
                        <dt>Fantamedia</dt>
                        <dd className="num">{stat(player['Media FantaVoto'])}</dd>
                    </div>
                    <div className="stage-stat">
                        <dt>FVM</dt>
                        <dd className="num">{Number.isFinite(fvm) ? Math.floor(fvm / 2) : '—'}</dd>
                    </div>
                </dl>
            </div>

            {/* I comandi sono parte del tabellone, non una barra sotto: il
                prezzo che si sta digitando e' l'unico numero che la stanza
                vuole vedere, e a caratteri piccoli in fondo alla pagina non lo
                vedeva nessuno. */}
            <div className="stage-assign">
                <p className="tv-eyebrow">Assegna a</p>
                <select
                    className="select stage-select"
                    aria-label="Assegna a"
                    value={participant}
                    onChange={(event) => onParticipant(event.target.value)}
                >
                    <option value="">Scegli…</option>
                    {participants.map((name) => (
                        <option key={name} value={name}>
                            {name}
                        </option>
                    ))}
                </select>
                <input
                    type="number"
                    min="1"
                    max={ceiling || undefined}
                    className="input stage-price num"
                    aria-label="Prezzo"
                    value={price}
                    onChange={(event) => onPrice(event.target.value)}
                    placeholder="0"
                />
                <p className="stage-budget">
                    {team ? (
                        <>
                            <span className="num">{team.budget}</span> crediti · max{' '}
                            <span className="num">{ceiling}</span> · {perSlot.toFixed(1)} per slot
                        </>
                    ) : (
                        'Scegli un partecipante'
                    )}
                </p>
                <button type="button" className="btn btn--go stage-go" onClick={onAssign}>
                    Assegna
                </button>
            </div>
        </section>
    );
}
